import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { apiCaller } from "../../../../services/AxiosInstance";
import { getImageUrl } from "../../../pages/Artist/ArtistAvatar";
import Swal from "sweetalert2";

const DirectImageUpload = ({
  fieldName,
  error,
  value,
  label,
  handleBlur,
  classes,
  inputType = "text",
  handleChange,
  inputProps,
  projectDetails,
  imageRatio,
  callBack,
  endPoint = "projects/update-details",
  allowSvg = false,
}) => {
  const fileInputRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [filePath, setFilePath] = useState(projectDetails?.[fieldName] ?? "");
  const [fileError, setFileError] = useState("");
  useEffect(() => {
    setFilePath(projectDetails?.[fieldName] ?? "");
  }, [projectDetails, fieldName]);
  const handleSelectClick = () => {
    fileInputRef.current.click(); // Open file dialog
  };

  useEffect(() => {
    return () => {
      setFileName("");
      setFilePath("");

      setSelectedFile(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      setFileName(""); // Show file name in input
    };
  }, []);

  const validateFile = (file) => {
    const FILE_SIZE = 5 * 1024 * 1024; // 5MB
    const SUPPORTED_FORMATS = ["image/jpg", "image/jpeg", "image/png"];
    if (allowSvg) {
      SUPPORTED_FORMATS.push(
        "image/svg+xml",
        "image/svg",
        "application/svg+xml"
      );
    }
    if (!SUPPORTED_FORMATS.includes(file.type)) {
      return allowSvg
        ? "Only JPG, JPEG, PNG, SVG are allowed"
        : "Only JPG, JPEG, PNG are allowed";
    }

    if (file.size > FILE_SIZE) {
      return "File size should be less than 5MB";
    }

    return null;
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const fileErrorMsg = validateFile(file);
      if (fileErrorMsg) {
        setFileError(fileErrorMsg);
        return;
      }
      setSelectedFile(file);
      setFileName(file.name); // Show file name in input
      setFileError("");
      // } else {
      //     setSelectedFile(null);
      //     fileInputRef.current.value = ""
      //     setFileName(""); // Show file name in input
    }
  };

  const handleRemoveClick = async () => {
    // if (!fileName && !filePath) return toast.error("Please upload a file first.");
    // if (!filePath) return toast.error("Please upload a file first.");
    if (filePath) {
      try {
        Swal.fire({
          title: "Are you sure to remove image ?",
          text: "You will not be able to recover the record !!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#BE282D",
          cancelButtonColor: "#aaa",
          confirmButtonText: "Yes, delete it!",
        })
          .then(async (result) => {
            if (result.isConfirmed) {
              const res = await apiCaller({
                method: "post",
                url: "remove-image",
                params: null,
                data: { key: filePath },
              });
              await apiCaller({
                method: "put",
                url: `${endPoint}/${projectDetails?._id}`,
                params: null,
                data: {
                  [fieldName]: "",
                },
              });
              if (callBack) {
                callBack();
              }
              if (res) {
                setFileName("");
                setFilePath("");

                setSelectedFile(null);
                fileInputRef.current.value = "";
                setFileName(""); // Show file name in input
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (err) {
        console.error(err);
        // alert("Error uploading file");
      }
      // setFileName("");
      // setFilePath("");

      // setSelectedFile(null);
      // fileInputRef.current.value = ""
      // setFileName(""); // Show file name in input
    } else {
      setFileName("");
      setFilePath("");

      setSelectedFile(null);
      fileInputRef.current.value = "";
      setFileName(""); // Show file name in input
    }
  };

  const handleUploadClick = async () => {
    if (!selectedFile && !filePath)
      return setFileError("Please select a file first.");

    try {
      setIsLoading(true);
      if (selectedFile) {
        const formData = new FormData();
        formData.append("file", selectedFile);
        const res = await apiCaller({
          method: "post",
          url: "upload",
          params: null,
          data: formData,
        });
        if (res?.data?.data?.url) {
          setFilePath(res?.data?.data?.url);
          await apiCaller({
            method: "put",
            url: `${endPoint}/${projectDetails?._id}`,
            params: null,
            data: {
              [fieldName]: res?.data?.data?.url,
            },
          });
          if (callBack) {
            callBack();
          }
          setIsLoading(false);
        } else {
          setFilePath("");
          setFilePath("");
          setIsLoading(false);
        }
      } else if (filePath) {
        const res = await apiCaller({
          method: "post",
          url: "remove-image",
          params: null,
          data: { key: filePath },
        });
        if (res) {
          await apiCaller({
            method: "put",
            url: `${endPoint}/${projectDetails?._id}`,
            params: null,
            data: {
              [fieldName]: "",
            },
          });
          if (callBack) {
            callBack();
          }
          setFileName("");
          setFilePath("");
          setIsLoading(false);
        }
      }
    } catch (err) {
      setIsLoading(false);
      setFilePath("");
      console.error(err);
      // alert("Error uploading file");
    }
  };

  return (
    <div
      className={`form-group ${classes ? classes : ""} mb-3 ${
        error ? "is-invalid" : "is-valid"
      }`}
    >
      <label className="text-label">{label}</label>
      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        onChange={handleFileChange}
        style={{ display: "none" }}
      />
      <div className={`d-flex m-0 ${filePath || fileName ? "gap-4" : ""}`}>
        <div className={imageRatio == "1_1" && filePath ? "" : "w-100"}>
          {filePath ? (
            <img
              src={getImageUrl(filePath)}
              alt="Uploaded"
              style={
                imageRatio == "1_1"
                  ? { width: "100px", height: "100px" }
                  : { width: "100%", maxHeight: "200px" }
              }
            />
          ) : (
            <div className="input-group">
              <input
                className="form-control"
                type="text"
                value={fileName}
                readOnly
                // placeholder="Select an image"
              />
              <button
                className="btn btn-primary"
                type="button"
                disabled={isLoading}
                onClick={handleSelectClick}
                style={{
                  background: "#F9FBFF",
                  color: "var(--abhi-color7)",
                  borderColor: "var(--abhi-color7)",
                }}
              >
                Select
              </button>
              {error && (
                <div
                  id={`val-${fieldName}-error`}
                  class="invalid-feedback animated fadeInUp"
                  style={{ display: "block" }}
                >
                  {error}
                </div>
              )}

              {fileError && (
                <div
                  id={`val-${fieldName}-error`}
                  class="invalid-feedback animated fadeInUp"
                  style={{ display: "block" }}
                >
                  {fileError}
                </div>
              )}
            </div>
          )}
        </div>
        <div className="">
          {filePath || fileName ? (
            <>
              <button
                disabled={isLoading}
                className="btn btn-primary"
                type="button"
                onClick={handleRemoveClick}
              >
                Remove
              </button>
            </>
          ) : null}
        </div>
      </div>
      {!filePath ? (
        <div className="d-flex mt-4 justify-content-end">
          <button
            disabled={isLoading}
            className="btn btn-primary"
            type="button"
            onClick={handleUploadClick}
          >
            Update
          </button>
        </div>
      ) : null}
    </div>
  );
};

export default DirectImageUpload;
